import React, { useEffect, useState } from 'react';

const EMOJIS = [
  { value: 1, emoji: '😠', label: 'Muito insatisfeito' },
  { value: 2, emoji: '😞', label: 'Insatisfeito' },
  { value: 3, emoji: '😐', label: 'Neutro' },
  { value: 4, emoji: '🙂', label: 'Satisfeito' },
  { value: 5, emoji: '😄', label: 'Muito satisfeito' },
];

export default function EmojiDisplay({ attributes, rowId, colId, setValue }) {
  const [selected, setSelected] = useState(attributes.value ?? null);

  useEffect(() => {
    setValue((oldValue) => {
      const newValue = [...oldValue];
      newValue[rowId].cols[colId].attributes.value = selected;
      newValue[rowId].cols[colId].attributes.errorMessage =
        !selected && attributes.required ? 'Selecione uma opção' : '';
      return newValue;
    });
  }, [selected, setValue, rowId, colId, attributes.required]);

  return (
    <div className="custom-input-container">
      <div className="displayed-label">
        <span>{attributes.ask}{attributes.required && '*'}</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '12px' }}>
        {EMOJIS.map((e) => (
          <div
            key={e.value}
            onClick={() => setSelected(e.label)}
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', cursor: 'pointer' }}
          >
            <span
              style={{
                fontSize: '36px',
                filter: selected !== null && selected !== e.label ? 'grayscale(1) opacity(0.4)' : 'none',
                transform: selected === e.label ? 'scale(1.2)' : 'scale(1)',
                transition: 'all 0.15s ease',
                display: 'block',
              }}
            >
              {e.emoji}
            </span>
            <small style={{ fontSize: '11px', textAlign: 'center', color: selected === e.label ? '#0d6efd' : '#6c757d' }}>
              {e.label}
            </small>
          </div>
        ))}
      </div>
    </div>
  );
}
